import {Navigate, Route, Routes} from "react-router-dom";
import Auth from "./views/auth/index.jsx";
import {PrivateRoute} from "./components/auth/privateRoute.jsx";
import Application from "./views/app/index.jsx";
import DisneyActivation from "./views/disney/index.jsx";

const isMainApp = window.location.hostname === "mlvm.apiws.co" || window.location.hostname === "localhost";
//https://disney.apiws.co/activate/eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IjItUjdrVmh2MmdkSnZtZDh6U3RodklUR2xfRVV5Qml0empkRGVDb05BYlUifQ.eyJvZmZlcklkIjoiMjQ1MWJhNDYtNzI1Yy00ZWZhLTkzNTItZjUzNTBiOTYzZGZkIiwicHJvZHVjdCI6ImNvbS5kaXNuZXkubnVwbGluLmNvLmJ1bmRsZS5wcmVtaXVtIiwibW9udGhzX3N1YnNjcmlwdGlvbiI6MSwic3ViamVjdElkIjoibm92YV8yNjgyOSIsImVudGl0bGVtZW50SWQiOiJub3ZhRU5UXzI2ODI5Iiwic3RhdHVzIjoiSU5JVElBVEVEIiwidGlwbyI6InNldCIsInBhcnRuZXJJZCI6Im5vdmEiLCJwcm92aWRlcklkIjoiTk9WQV9DTyIsImlzcElkIjoibm92YV9jbyIsImZ1bGxmaWxtZW50Y2hhbm5lbCI6Ik5PVkEiLCJwYWlzIjoiY28iLCJpYXQiOjE3NzY4MDQyNzAsImV4cCI6MTc3NjgxMTQ3MH0.wlaU6iqcN-_vKKu867W4q-SYTqMjrZ9pFmYJxoYUL2-3r26eW9aQQQHUdWIJAh27HTRtZeUWVWyKLmaETF9SZPiwbF3H1fITCG9Y8owVUGtfj4hR1gN4JRXNOBU9BZyaeGtuPd-31oBy5_q8tNLnJ1Z1jzt0nOqTNlvILLQ1hiyoxjazEDEnvl6L1sQLguCX2fgPlhbcj_mrLasaIb-unauxEG0KAPmJOiSURgMWqcw-rYmm3afeLBUxYEELh5wQJqWhedMQAFmQelO6S1SKKMCXe9SwyIaCWYt3ddGSpL3btiQNSDDJj0d0kwJ2owuEEefzR_ALgNNoKIXJ44ceKQ
function App(props) {
  if (!isMainApp) {
    return (
      <Routes>
        <Route path="/activate/:token" element={<DisneyActivation />}/>
        <Route path={'*'} element={<Navigate to={'/disney/invalid'}/>}/>
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/app"/>}/>
      <Route path="/app/*" element={<PrivateRoute {...props} />}>
        <Route path="*" index element={<Application {...props} />} />
      </Route>
      <Route path="/auth/*" element={<Auth {...props} />}/>
      <Route path="/disney/:token" element={<DisneyActivation />}/>
      <Route path={'*'} element={<Navigate to={'./'}/>}/>
    </Routes>
  )
}

export default App
